import { Amplify, Auth, Storage } from "aws-amplify";
import { API } from "aws-amplify/lib-esm";

Amplify.configure({
  Auth: {
    // REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
    identityPoolId: "ap-southeast-1:88a2f419-a633-4029-a6eb-142e5fb970dd",

    // REQUIRED - Amazon Cognito Region
    region: "ap-southeast-1",

    // OPTIONAL - Amazon Cognito Federated Identity Pool Region
    // Required only if it's different from Amazon Cognito Region
    identityPoolRegion: "ap-southeast-1",

    // OPTIONAL - Amazon Cognito User Pool ID
    userPoolId: "ap-southeast-1_S6YnnUTIq",

    // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
    userPoolWebClientId: "6ttmls1oc0q72agork8ll68e6q",

    // OPTIONAL - Enforce user authentication prior to accessing AWS resources or not
    mandatorySignIn: false,

    // OPTIONAL - This is used when autoSignIn is enabled for Auth.signUp
    // 'code' is used for Auth.confirmSignUp, 'link' is used for email link verification
    signUpVerificationMethod: "code", // 'code' | 'link'

    // OPTIONAL - Manually set the authentication flow type. Default is 'USER_SRP_AUTH'
    authenticationFlowType: "USER_PASSWORD_AUTH",
  },
  Storage: {
    AWSS3: {
      bucket: "tearetina", //REQUIRED -  Amazon S3 bucket name
      region: "ap-southeast-1", //OPTIONAL -  Amazon service region
    },
  },
  API: {
    endpoints: [
      {
        name: "teabase",
        endpoint:
          "https://y3nc8dkrn7.execute-api.ap-southeast-1.amazonaws.com/development",
      },
      {
        name: " AdminQueries",
        endpoint:
          "https://nfifv2p0q4.execute-api.ap-southeast-1.amazonaws.com/dev",
      },
    ],
  },
});

// You can get the current config object
const currentConfig = {
  Auth: Auth.configure(),
  Storage: Storage.configure(),
  API: API.configure(),
};
export default currentConfig;